import React, { useState } from "react";
import "./Body.css";
import ProjectItem from "./ProjectItem";
import InvisibleTreehouseBio from "./PortfolioBios/InvisibleTreehouseBio";
import useInView from "../hooks/useInView";
import projects from "../data/projects";

function Body() {
	const [myRef, visible] = useInView();
	const [activeProject, setActiveProject] = useState(null);
	const [hoveredProject, setHoveredProject] = useState(null);

	const displayedProject = hoveredProject ?? activeProject;

	return (
		<div className="body" id="portfolio">
			<div className="shimmer body_portfolio_background">portfolio</div>
			<div
				ref={myRef}
				className={`${visible ? "body_reveal" : "body_reveal_inactive"}`}
			>
				<div className="page_body_container">
					<div className="body_wrapper">
						<div className="body_content">
							<div className="info" id="info">
								{displayedProject ? (
									<InvisibleTreehouseBio
										projectBio={displayedProject.bio}
										projectTitle={displayedProject.title}
										pinned={!!activeProject && !hoveredProject}
									/>
								) : (
									<div className="placeholder">
										<p>Hover to preview · Click to pin</p>
									</div>
								)}
							</div>
							<div className="body_items">
								{projects.map((project) => (
									<div key={project.id}>
										<ProjectItem
											src={project.src}
											text={project.text}
											link={project.link}
											handleInfoClick={() => setActiveProject(project)}
											handleMouseEnter={() => setHoveredProject(project)}
											handleMouseLeave={() => setHoveredProject(null)}
										/>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Body;
